
<!--legacy 
    <app-comment-list  *ngIf= 'qs.enable("genFeedback")' [featureType] = qs.offering [cmntType]= "'Hinfo'" [parentHdrId] = qs.chapter  [hideTitle]= false ></app-comment-list> 
-->


<app-cmnt-list  *ngIf= 'qs.enable("genFeedback")' [featureType] = qs.offering [cmntType]= "'Hinfo'" [mode] = '"list"' [parentHdrId] = qs.chapter></app-cmnt-list> 
